<template>
  <SectionContentNumberedGuideCard v-bind="props" />
</template>

<script setup>
const props = defineProps({
  number: {
    type: String,
    default: '01'
  },
  eyebrow: {
    type: String,
    default: 'First Up'
  },
  title: {
    type: String,
    default: 'Diet & Nutrition'
  },
  theme: {
    type: String,
    default: 'green'
  },
  introContent: {
    type: String,
    default: `<p>Nutrition plays a vital role in men's health.</p>
<p>Everything from heart health to testosterone levels, cognitive health, weight management, muscle building, and more can all be helped or hindered by what you're putting into your body.</p>
<p>To support each of the areas we've discussed today, focus on consuming nutrient dense, whole foods.</p>
<p>You've likely heard me mention this, but I like to live by the 80/20 rule.</p>`
  },
  splitCards: {
    type: Array,
    default: () => [
      {
        value: '80%',
        text: 'Dial it in. Eat clean, whole, nutritious foods that support and fuel health.',
        variant: 'green'
      },
      {
        value: '20%',
        text: "Enjoy life. A drink with friends. A slice of pizza at your kid's party. No guilt.",
        variant: 'neutral'
      }
    ]
  },
  outroContent: {
    type: String,
    default: `<p>Maybe this means having an alcoholic beverage while out with friends? Perhaps this looks like eating a slice of pizza at your kid's birthday party?</p>
<p>No matter how you cut it, no matter how you enjoy that 20%, just make sure this isn't your norm, instead focusing on real, nutritious, great tasting food for optimal fuel the majority of the time.</p>`
  },
  quoteContent: {
    type: String,
    default: ''
  },
  sideContent: {
    type: String,
    default: ''
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: ''
  },
  tipsTitle: {
    type: String,
    default: ''
  },
  tipsContent: {
    type: String,
    default: ''
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  },
  paddingBottom: {
    type: String,
    default: 'reduced'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Guide Diet Nutrition',
  inputs: [
    {
      name: 'number',
      type: 'text',
      defaultValue: '01'
    },
    {
      name: 'eyebrow',
      type: 'text',
      defaultValue: 'First Up'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Diet & Nutrition'
    },
    {
      name: 'theme',
      type: 'text',
      enum: ['green', 'brown', 'gold'],
      defaultValue: 'green'
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: `<p>Nutrition plays a vital role in men's health.</p>
<p>Everything from heart health to testosterone levels, cognitive health, weight management, muscle building, and more can all be helped or hindered by what you're putting into your body.</p>
<p>To support each of the areas we've discussed today, focus on consuming nutrient dense, whole foods.</p>
<p>You've likely heard me mention this, but I like to live by the 80/20 rule.</p>`
    },
    {
      name: 'splitCards',
      type: 'list',
      defaultValue: [
        {
          value: '80%',
          text: 'Dial it in. Eat clean, whole, nutritious foods that support and fuel health.',
          variant: 'green'
        },
        {
          value: '20%',
          text: "Enjoy life. A drink with friends. A slice of pizza at your kid's party. No guilt.",
          variant: 'neutral'
        }
      ],
      subFields: [
        {
          name: 'value',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'text',
          type: 'longText',
          defaultValue: ''
        },
        {
          name: 'variant',
          type: 'text',
          enum: ['green', 'neutral'],
          defaultValue: 'green'
        }
      ]
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: `<p>Maybe this means having an alcoholic beverage while out with friends? Perhaps this looks like eating a slice of pizza at your kid's birthday party?</p>
<p>No matter how you cut it, no matter how you enjoy that 20%, just make sure this isn't your norm, instead focusing on real, nutritious, great tasting food for optimal fuel the majority of the time.</p>`
    },
    {
      name: 'quoteContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'sideContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tipsTitle',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tipsContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
